import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, Pagination } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faPlus,
    faBan,
    faFilter,
    faPercentage,
    faPercent,
    faCog,
} from "@fortawesome/free-solid-svg-icons";
import EditDowntimeReason from "./EditDowntimeReason";
import { downTimeReasonApi, delete_downtime_reason, create_downtime_reason } from "../../../api";
import { Tooltip } from "react-tooltip";
import { Trash2 } from "react-feather";
const schema = yup.object().shape({
    downtimeReasonName: yup.string().required("Downtime reason is required"),
    colorCode: yup.string().required("Color is required"),
    category: yup.string().nullable(),
});

function DowntimeReason() {
    const [visible, setVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [srNo, setSrNo] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [dataList, setDataList] = useState({
        data: [],
        loading: true,
        totalRecords: "",
    });
    const [filterConfig, setFilterConfig] = useState({
        searchVal: "",
        categoryVal: "",
    });

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
    });

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            fetchReasons(1, entriesPerPage);
        }, 1000); // Adjust the delay as needed (e.g., 500 milliseconds)

        return () => {
            clearTimeout(debounceTimeout); // Clear the timeout if searchTerm changes before the timeout expires
        };
    }, [filterConfig.searchVal, filterConfig.categoryVal]);


    function clearFilter() {
        setFilterConfig({ searchVal: "", categoryVal: "" });
    }

    function fetchReasons(pg = page, epp = entriesPerPage) {
        setDataList((prev) => ({ ...prev, loading: true }));

        const payload = {
            pageNo: Number(pg),
            entriesPerPage: Number(epp),
        };

        if (filterConfig.searchVal?.length > 0) {
            payload.downtime_reason = filterConfig.searchVal;
        }

        if (filterConfig.categoryVal?.length > 0) {
            payload.categoryVal = filterConfig.categoryVal;
        }

        downTimeReasonApi(payload).then(
            (res) => {
                setDataList({
                    data: res.data.data || [],
                    loading: false,
                    totalRecords: res.data.total || 0,
                });

                setMaxPage(Math.ceil((res.data.total || 0) / Number(epp)));

                setPage(pg);
                if (pg === 1) setSrNo(0);
            },
            () => {
                setDataList({ data: [], loading: false, totalRecords: 0 });
            }
        );
    }


    const onSubmit = async (data) => {
        try {
            const payload = {
                downtime_reason: data.downtimeReasonName,
                color_code: data.colorCode,
                category: data.category || null,
            };

            await create_downtime_reason(payload);

            toast.success("Downtime reason created successfully");
            setVisible(false);
            reset();
            fetchReasons();

        } catch (error) {
            console.log("error", error);

            toast.error(
                error?.response?.data?.message || "Something went wrong",
                { autoClose: 2000 }
            );
        }
    };


    const deleteReason = (row) => {
        SweetAlert.fire({
            title: "Are you sure?",
            text: "This record will be deleted",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ok",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await delete_downtime_reason({ uuid: row.uuid });

                    toast.success("Deleted successfully");
                    fetchReasons();
                } catch (error) {
                    console.log("error", error);

                    toast.error(
                        error?.response?.data?.message || "Failed to delete record"
                    );
                }
            }
        });
    };


    function openNav() {
        document.getElementById("mySidebar").style.width = "320px";
        document.getElementById("root_div_main").style.marginLeft = "320px";
        setTimeout(() => {
            document.getElementById("mySidebar").style.overflowX = "visible";
        }, 200);
    }

    function closeNav() {
        document.getElementById("mySidebar").style.width = "0";
        document.getElementById("root_div_main").style.marginLeft = "0";

        document.getElementById("mySidebar").style.overflowX = "hidden";
    }

    console.log("dataList", dataList);
    return (
        <React.Fragment>
            <ToastContainer />

            <div className="min-vh-100" id="root_div_main">
                <Modal show={visible} onHide={() => setVisible(false)} size={"md"}>
                    <Modal.Header
                        style={{ background: "#2A3643", color: "white" }}
                        closeButton
                    >
                        <Modal.Title>
                            {"Add Downtime Reason"}
                        </Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Modal.Body>
                            <div className="form-group row mt-2">
                                <label
                                    style={{ fontSize: "14px" }}
                                    className="col-form-label col-md-12 bold"
                                >
                                    {"Category"}
                                </label>
                                <div className="col-md-12 mb-2">
                                    <select
                                        className={
                                            errors.category ? "form-control is-invalid" : "form-control"
                                        }
                                        id="category"
                                        name="category"
                                        {...register("category")}
                                    >
                                        <option value="">Select category</option>
                                        <option value="Loading">Loading</option>
                                        <option value="Downtime">Downtime</option>
                                    </select>
                                    <span className="text-danger err-msg">
                                        {errors.category?.message}
                                    </span>
                                </div>

                                <label
                                    style={{ fontSize: "14px" }}
                                    className="col-form-label col-md-12 bold"
                                >
                                    {"Reason Name"}
                                    <span className="text-danger"> *</span>
                                </label>
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        className={
                                            errors.downtimeReasonName ? "form-control  is-invalid" : "form-control "
                                        }
                                        id="downtimeReasonName"
                                        name="downtimeReasonName"
                                        placeholder="Enter reason name"
                                        {...register("downtimeReasonName")}
                                    />
                                    <span className="text-danger err-msg">
                                        {errors.downtimeReasonName?.message}
                                    </span>
                                </div>

                                <div className="col-md-12 mb-2">
                                    <label style={{ fontSize: "14px" }}
                                        className="col-form-label col-md-12 roboto-bold">{"Color"}
                                        <span className="text-danger">*</span></label>
                                    <div className="d-flex gap-2 align-items-center">
                                        <input type="color" {...register("colorCode")} />
                                        <span
                                            className="px-3 py-1 rounded-pill text-white"
                                            style={{ background: watch("colorCode") || "#999" }}
                                        >
                                            Preview
                                        </span>
                                    </div>
                                    <span className="text-danger">{errors.colorCode?.message}</span>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="submit" className="f-16 btn btn-yellow">
                                Save
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal>
                <div id="mySidebar" className="customsidebar">
                    <a className="closebtn" onClick={() => closeNav()}>
                        ×
                    </a>

                    <div className=" content">
                        <div>
                            <label
                                className="filterLabel mb-1 bold"
                                style={{ fontSize: "14px" }}
                            >
                                {"Search"}
                            </label>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Search downtime reason"
                                value={
                                    filterConfig.searchVal.length > 0
                                        ? filterConfig.searchVal
                                        : ""
                                }
                                onChange={(e) =>
                                    setFilterConfig((prev) => ({
                                        ...prev,
                                        searchVal: e.target.value,
                                    }))
                                }
                            />
                        </div>
                        <div className="mt-3">
                            <label
                                className="filterLabel mb-1 bold"
                                style={{ fontSize: "14px" }}
                            >
                                {"Category"}
                            </label>
                            <select
                                className="form-control form-control-sm"
                                value={filterConfig.categoryVal || ""}
                                onChange={(e) => {
                                    setFilterConfig({
                                        ...filterConfig,
                                        categoryVal: e.target.value,
                                    });
                                }}
                            >
                                <option value="">All</option>
                                <option value="Loading">Loading</option>
                                <option value="Downtime">Downtime</option>
                            </select>
                        </div>
                        <div className="my-3 d-flex justify-content-end">
                            <button
                                onClick={() => clearFilter()}
                                className="btn btn-sm btn-yellow "
                            >
                                <FontAwesomeIcon
                                    style={{ color: "#344454" }}
                                    icon={faBan}
                                    size="sm"
                                />{" "}
                                {"Clear Filter"}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="content-wrapper">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="page-heading">{"Downtime Reason"}</h1>
                        <div>
                            <span
                                className="cursor_pointer px-3 me-0 me-md-2"
                                onClick={() => {
                                    openNav();
                                }}
                            >
                                <FontAwesomeIcon
                                    style={{ marginRight: "5px" }}
                                    icon={faFilter}
                                    size="sm"
                                />
                                {"Filter Menu"}
                            </span>


                            <button
                                className="btn btn-pink px-4"
                                onClick={() => {
                                    setVisible(true);
                                    reset();
                                }}
                            >
                                <FontAwesomeIcon
                                    style={{ color: "#fff" }}
                                    icon={faPlus}
                                    size="sm"
                                />{" "}
                                {"Add Downtime Reason"}
                            </button>

                        </div>
                    </div>
                    <div className="card border-0 mt-4">
                        <div className="card-body">
                            <div className="mt-3">
                                {dataList.loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : dataList && dataList.data?.length > 0 ? (
                                    <>
                                        <div className="table-responsive">
                                            <table
                                                className="table table-striped table-sm"
                                                width={"100%"}
                                            >
                                                <thead className="table-grey">
                                                    <tr className="">
                                                        <th scope="col" width="15%">
                                                            {"Sr.No"}
                                                        </th>

                                                        <th scope="col">
                                                            {"Category"}
                                                        </th>

                                                        <th scope="col">
                                                            {"Reason"}
                                                        </th>

                                                        <th scope="col">
                                                            {"Color"}
                                                        </th>


                                                        <th scope="col" width="15%">
                                                            {"Action"}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="">
                                                    {dataList.data?.map((val, i) => (
                                                        <tr key={i} className="">
                                                            {/* <td>{val.NCReasonId}</td> */}
                                                            <td>{i + parseInt(srNo) + 1}</td>

                                                            <td>
                                                                {val.category && val.category !== "" ? val.category : "-"}
                                                            </td>

                                                            <td >
                                                                {val.downtime_reason && val.downtime_reason !== "" ? val.downtime_reason : "NA"}

                                                            </td>
                                                            <td>
                                                                {val.color_code ? (
                                                                    <span
                                                                        className="px-3 py-1 rounded-pill"
                                                                        style={{
                                                                            backgroundColor: val.color_code,
                                                                            display: "inline-block",
                                                                            minWidth: "50px",
                                                                            height: "20px",
                                                                        }}
                                                                    ></span>

                                                                ) : (
                                                                    "NA"
                                                                )}
                                                            </td>

                                                            <td>



                                                                <EditDowntimeReason
                                                                    data={val}
                                                                    fetchReasons={fetchReasons}
                                                                    page={page}
                                                                    entriesPerPage={entriesPerPage}
                                                                />


                                                                <>
                                                                    <Tooltip
                                                                        id={"delete-tooltip" + i}
                                                                        place="top"
                                                                    />
                                                                    <div
                                                                        data-tooltip-id={"delete-tooltip" + i}
                                                                        data-tooltip-content={"Delete downtime reason"
                                                                        }
                                                                        className="deleteIcon me-2"
                                                                        onClick={() => deleteReason(val)}
                                                                    >
                                                                        <Trash2 color="#FFFFFF" size={18} />
                                                                    </div>
                                                                </>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <p className="mb-0">{`Showing ${parseInt(srNo) + 1
                                                } to ${Math.min(
                                                    parseInt(entriesPerPage) + parseInt(srNo),
                                                    dataList.totalRecords
                                                )} of ${dataList.totalRecords} entries`}</p>
                                            <Pagination>
                                                <Pagination.Prev
                                                    disabled={page === 1 ? true : false}
                                                    onClick={() => {
                                                        fetchReasons(
                                                            page - 1,
                                                            entriesPerPage,
                                                            parseInt(srNo) - parseInt(entriesPerPage)
                                                        );
                                                        setSrNo((prevC) =>
                                                            page - 1 == 1
                                                                ? 0
                                                                : prevC - parseInt(entriesPerPage)
                                                        );
                                                        setPage(page - 1);
                                                    }}
                                                >
                                                    {"Prev"}
                                                </Pagination.Prev>

                                                <Pagination.Item active>{page}</Pagination.Item>

                                                <Pagination.Next
                                                    disabled={
                                                        page === maxPage ||
                                                            maxPage === 0 ||
                                                            entriesPerPage > dataList.data.length
                                                            ? true
                                                            : false
                                                    }
                                                    onClick={() => {
                                                        fetchReasons(
                                                            page + 1,
                                                            entriesPerPage,
                                                            parseInt(srNo) + parseInt(entriesPerPage)
                                                        );
                                                        setSrNo(
                                                            (prevC) => prevC + parseInt(entriesPerPage)
                                                        );
                                                        setPage(page + 1);
                                                    }}
                                                >
                                                    {"Next"}
                                                </Pagination.Next>
                                            </Pagination>
                                        </div>
                                    </>
                                ) : (
                                    <p className="text-danger mb-0 f-22 text-center mt-4">
                                        {"Downtime reason not found !"}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default DowntimeReason
